import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import * as Sentry from '@sentry/browser'
import { Nav, Navbar } from 'react-bootstrap'

import { isAnyPartOfElementInViewport } from '../../actions/actions'

class LibraryWrap extends React.PureComponent {
  constructor(props) {
    super(props)
    this.contactFormRef = null
    this.state = {
      listenerComplete: false
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    this.handleScroll(null)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    if (this.state.listenerComplete) {
      return
    }

    const itms = document.querySelectorAll('.section:not(.has-been-viewed)')

    itms.forEach(selectedEle => {
      console.log(selectedEle, isAnyPartOfElementInViewport(selectedEle))

      if (isAnyPartOfElementInViewport(selectedEle)) {
        selectedEle.classList.add('has-been-viewed')
      }
    })
  }

  findLogo = () => {
    return '/images/assets/library/horizontal/dark.svg'
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
  }

  makeLink = path => {
    return path
  }

  render() {
    const props = this.props
    let path = window.location.pathname

    if (this.props.params && this.props.params.state) {
      path = path.slice(this.props.params.state.length + 2)
    } else {
      path = path.slice(1)
    }

    return (
      <div className="feature-section">
        <Navbar collapseOnSelect={true} fixedTop>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to={this.makeLink('/')}>
                <img
                  src={this.findLogo()}
                  style={{ height: '50px' }}
                  alt="Headed2 Logo"
                />
              </Link>
            </Navbar.Brand>
          </Navbar.Header>
          <Nav pullRight>
            <li role="presentation">
              <Link to="/requestdemo" className="btn btn-default btn-lg navbar-btn">
                Request Demo Account
              </Link>
            </li>
            <li role="presentation">
              <Link to="/quote" className="btn btn-success btn-lg navbar-btn">
                Get a Quote
              </Link>
            </li>
          </Nav>
        </Navbar>

        <div style={{ minHeight: '50vh', marginTop: '100px' }} className="homesection">
          <div>
            <div className="container">
              <div>
                <h2 className="page-title" style={{ fontWeight: '300' }}>
                  Solutions for <b>Libraries</b> with <b>CareerExplorer</b>
                </h2>
              </div>
            </div>

            <div className="section">
              <div
                className="title-block-bar"
                style={{ paddingTop: '75px', backgroundColor: '#6a3460' }}>
                <div className="container">
                  <h3 style={{ color: 'white' }}>
                    Roughly <b>30%</b> of the workforce will change careers or jobs{' '}
                    <b>every 12 months</b>.
                  </h3>
                  <div className={'row  equal-height'}>
                    <div className={'fcol col-sm-8'}>
                      <p style={{ fontSize: '1.2rem' }}>
                        Career switching and job changing is now more commonplace than
                        ever before. With so much labor churn, more than ever before
                        public libraries are perfectly situated to help this population by
                        providing resources to help ease and navigate these transitions.
                        Including access to the CareerExplorer career information database
                        as part of this offering can help turbo-charge their career
                        search.
                      </p>
                    </div>
                    <div className="fcol fcol-bottom col-sm-4">
                      <img
                        src="/images/library/Webpage/SVG/Header-Img.svg"
                        className="img-responsive"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <div className="container">
                <div className={'row'}>
                  <div className={'col-sm-8'}>
                    <h3>
                      Career <b>Information Database</b>
                    </h3>
                    <p style={{ fontSize: '1.2rem' }}>
                      The CareerExplorer system provides a comprehensive collection of
                      career exploration and planning resources, including
                      self-assessments, resume and reference writing, occupations and
                      training, and job postings. It provides full coverage for 900
                      occupations, 8,000 industry certifications and 6,700 postsecondary
                      institutions spanning 16 career clusters. It also contains
                      comprehensive labor market information, including in-demand
                      occupations, wages, and employment data.
                    </p>
                  </div>
                  <div className="col-sm-4">
                    <div className="col-xs-6 factoid">
                      <img
                        src="/images/library/Webpage/SVG/icon-Occupation.svg"
                        className="img-responsive"
                      />
                      <span className={'callout'}>900</span>
                      Occupations
                    </div>
                    <div className="col-xs-6 factoid">
                      <img
                        src="/images/library/Webpage/SVG/Icon-Certification.svg"
                        className="img-responsive"
                      />
                      <span className={'callout'}>8,000</span>
                      Industry Certifications
                    </div>
                    <div className="col-xs-6 factoid">
                      <img
                        src="/images/library/Webpage/SVG/Icon-Institutions.svg"
                        className="img-responsive"
                      />
                      <span className={'callout'}>6,700</span>
                      Postsecondary Institutions
                    </div>
                    <div className="col-xs-6 factoid">
                      <img
                        src="/images/library/Webpage/SVG/Icon-Clusters.svg"
                        className="img-responsive"
                      />
                      <span className={'callout'}>16</span>
                      Career Clusters
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <div
                className="title-block-bar"
                style={{ paddingTop: '75px', backgroundColor: '#eee' }}>
                <div className="container">
                  <div className={'row'}>
                    <div className="col-xs-12">
                      <h3>
                        Career <b>Navigation System</b>
                      </h3>
                      <p style={{ fontSize: '1.2rem', color: 'black' }}>
                        The CareerExplorer is engineered to provide the most appropriate
                        research experience to patrons, examples include:
                      </p>
                      <ul style={{ columnCount: '2', columnGap: '50px' }}>
                        <li className="check">
                          Personal assessments to determine career information needs
                        </li>
                        <li className="check">
                          Simple search that quickly delivers relevant results including
                          job openings, occupations, college majors, industry
                          certifications, postsecondary institutions and employers
                        </li>
                        <li className="check">
                          Personalized Career Hub to keep track of assessment results,
                          career plans and employment resources
                        </li>
                        <li className="check">
                          Easy-to-browse categories including industry sectors, career
                          clusters and career pathways
                        </li>
                        <li className="check">
                          Occupational overviews that provide a starting point for career
                          research
                        </li>
                        <li className="check">
                          Colorful, mobile friendly design with custom content that
                          provides context to users
                        </li>
                        <li className="check">
                          Career readiness lesson plans to facilitate career development
                          planning
                        </li>
                        <li className="check">
                          In-product help features and video-based tutorials to help Users
                          understand the features and functionality
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <div className="container" style={{ paddingTop: '25px' }}>
                <div className="row">
                  <div className={'col-sm-5'}>
                    <h3>
                      <b>More engaging</b>.<br /> Simple as that.
                    </h3>
                    <p style={{ color: ' #000', fontSize: '1rem' }}>
                      The CareerExplorer was designed from the ground up with the end user
                      in mind. Throughout the system, you will find an easy to understand
                      presentation with engaging graphics and an intuitive interface.
                      Plus, our responsive design makes the system useable on desktop and
                      mobile devices.
                    </p>
                  </div>
                  <div className="col-sm-7">
                    <img
                      src="/images/www/new/advantage/CareerExploration-UsersInterface.svg"
                      className="img-responsive image-grow"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <div
                className="title-block-bar"
                style={{ paddingTop: '75px', backgroundColor: '#6a3460' }}>
                <div className="container">
                  <div className={'row'}>
                    <div className={'col-sm-6'}>
                      <h3 style={{ color: 'white' }}>
                        A Proven <b>Partner</b> for <b>Libraries</b>
                      </h3>
                      <p style={{ fontSize: '1.2rem' }}>
                        The Headed2 CareerExplorer has been used successfully by libraries
                        in several localities, and our partnership with the NV Library has
                        received national attention. Additionally, our partnership with
                        CALIFA makes procurement easier for your library.
                      </p>
                    </div>
                    <div
                      className="col-sm-6 text-center"
                      style={{
                        backgroundSize: 'contain',
                        minHeight: '320px',
                        backgroundRepeat: 'no-repeat',
                        paddingTop: '30px',
                        backgroundImage:
                          'url(/images/library/Webpage/SVG/BG-CaseStudy.svg)'
                      }}>
                      <img
                        src={'/images/assets/nevada/horizontal/dark.svg'}
                        style={{ maxWidth: '50%' }}
                      />

                      <p style={{ color: 'black', padding: '25px' }}>
                        Find out how Nevada State Library Archive & Public Records
                        (NSLAPR) sought to make the ultimate Career Readiness database and
                        platform available to library card holders throughout the state.
                      </p>

                      <Link
                        to={this.makeLink('/casestudy/nevada')}
                        className="btn btn-success btn-lg navbar-btn">
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <div className="container" style={{ paddingTop: '25px' }}>
                <div className="row">
                  <div className="col-sm-7">
                    <img
                      src="/images/library/Webpage/SVG/CareerResources-Img.svg"
                      className="img-responsive image-grow"
                    />
                  </div>
                  <div className={'col-sm-5'}>
                    <h3>
                      Emphasize Your <b>Career Resources</b> and <b>Programs</b>
                    </h3>
                    <p style={{ color: ' #000', fontSize: '1rem' }}>
                      Your library works hard to make great programs available to its
                      patrons but making them aware of everything that is available can be
                      challenging. The CareerExplorer’s Local Opportunities Network can
                      help you surface this information to users, in a contextual and
                      relevant manner. Users can bookmark and engage with these
                      opportunities as they are exploring careers.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <div className="container" style={{ paddingTop: '75px' }}>
                <div className="row">
                  <div className={'col-sm-7'}>
                    <h3>
                      Career Exploration for <b>Younger Learners</b>
                    </h3>
                    <p style={{ color: ' #000', fontSize: '1rem' }}>
                      Up the Ladder is an easy to navigate career education platform that
                      is full of fun for younger patrons. With engaging, colorful graphic
                      design, and innovative text-to-speech capabilities, Up the Ladder is
                      the perfect way to introduce career exploration to your upper
                      elementary and middle school learners all within the CareerExplorer
                      .
                    </p>
                  </div>
                  <div className="col-sm-5">
                    <img
                      src="/images/library/Webpage/SVG/UTL-Img.svg"
                      className="img-responsive image-grow"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={'section'}>
              <div
                className="title-block-bar nobottom"
                style={{ paddingTop: '75px', backgroundColor: '#f3e3f0' }}>
                <div className="container text-center">
                  <h3>Have a Question?</h3>
                  <p style={{ color: ' #000', fontSize: '1rem' }}>
                    Our team is here to answer your questions about the CareerExplorer
                    Library Edition
                  </p>
                  <Link to={`/quote`} className="btn btn-success btn-lg">
                    Ask Us
                  </Link>
                </div>
              </div>
            </div>

            <div className={'section'}>
              <div
                style={{
                  paddingTop: '75px',
                  paddingBottom: '25px',
                  marginTop: '0',
                  backgroundColor: '#eee'
                }}>
                <div className="container">
                  <div className={'row'}>
                    <div className="col-sm-8">
                      <h3 style={{ marginBottom: '25px' }}>
                        About <b>Headed2</b> and the <b>CareerExplorer</b>
                      </h3>
                      <p style={{ color: 'black' }}>
                        For over 15 years, Headed2 has been helping individuals plan for
                        their future and explore the world of work. In that time, we have
                        grown into a reliable and robust platform that services millions
                        of individuals each year from across the United States.
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <img src="/images/www/new/abouth2/AboutH2-HeaderImg.svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: '#000', minHeight: '50px' }}>
              <div className="container">
                <span style={{ color: 'white', lineHeight: '50px' }}>
                  Copyright {new Date().getFullYear()},{' '}
                  <a
                    style={{ color: 'white' }}
                    href="https://www.powerschool.com/privacy-statement-overview/">
                    PowerSchool Group LLC
                  </a>
                </span>
              </div>
            </div>
          </div>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      formRequest: state.forms.formRequest
    }
  },
  dispatch => {
    return { dispatch }
  }
)(LibraryWrap)
